import React from 'react';
import FeeWaiverAllocation from './FeeWaiverAllocation';
import '../../../CommonCSS/SocietyCSS.css'

const FeeWaiverAllocationApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Fees Waiver Allocation</h5>
          </div>  
        </div>
        <FeeWaiverAllocation/>
      </div>
    </div >
  );
};

export default FeeWaiverAllocationApp;
